import amaLog from "../helpers/log";

const hostInfo = (): { isSeOcelot: boolean, siteName: string, isBlog: boolean, blogHost: string } => {
  let isBlog = false;
  let blogHost = '';
  let host: string = (typeof window !== 'undefined' ? window.ama?.hostName || window.location.hostname : '').toLowerCase();

  if (host.startsWith('www.')) {
    host = host.slice(4);
  }

  if (host === 'mabra.com') return { isSeOcelot: true, siteName: 'mabra', isBlog: false, blogHost: '' };

  const parts: string[] = host.split('.');

  if (parts.length >= 3) return { isSeOcelot: false, siteName: '', isBlog: true, blogHost: parts[1] };

  const [siteName, tld] = parts;

  return {
    isSeOcelot: (tld === 'se' && siteName !== 'recept'),
    siteName,
    isBlog,
    blogHost
  };
};
let amaModulesCache: any = null;
const adTagsSites = {
  motherhood: {},
  elle: {},
  residencemagazine: {},
  mabra: {},
  svenskdam: {},
  hant: {},
  femina: {},
  allas: {},
};
const isAllowedMotherhoodPage =  (): boolean => {
  try {
    const url = new URL(window.location.href);
    if (!['motherhood.se', 'www.motherhood.se'].includes(url.hostname)) {
      return false;
    }
    const path = url.pathname.replace(/\/$/, '') || '/';

    if (path === '/') return true;

    if (path === '/mammaliv' || path.startsWith('/mammaliv/')) {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
};
export default function getModules() {
  if (amaModulesCache) return amaModulesCache;

  const { siteName, isSeOcelot, isBlog, blogHost } = hostInfo();
  const loadGptSites = ['motherhood'];
  const multivideoSites: string[] = [];
  const searchParamExist = window.location.search.includes('multivideo=1');
  const amaConsoleParamExist = window.location.search.includes('amaConsole=true');
  const amaConsoleSites: string[] = ['motherhood'];
  const isMultivideoSite = multivideoSites.includes(siteName) || (isBlog && multivideoSites.includes(blogHost) && searchParamExist);
  const adTags = adTagsSites[siteName as keyof typeof adTagsSites] || null;
  const dmScript = isMultivideoSite ? 'https://ads.rubiconproject.com/prebid/13012_Allas_exp.28.js' : undefined;
  const consoleScript = amaConsoleSites.includes(siteName) && amaConsoleParamExist ? 'https://cdn.allermedia.se/aller-ads-console/aller-ads-console.bundle.js' : undefined;

  amaModulesCache = {
    adsConsoleScript: consoleScript,
    prebidScript: dmScript,
    useStats: true,
    useLimitedAds: true,
    useGrowthbook: true,
    useGLazyLoad: ['responsive_1', 'top_ad'],
    useFirstWaveBatching: false,
    useSingleRequest: false,
    useDivModificationsOnMainCat: true,
    usePrebidVideo: true,
    useVerticals: isSeOcelot,
    useSecondArticle: isSeOcelot,
    usePlacementCheck: isSeOcelot,
    useLoadResourcesBeforeConsent: false, // Add back when perf stats exists - isSeOcelot && siteName === 'motherhood',
    useLoadGptByAdsLib: loadGptSites.includes(siteName),
    useLoadDmByAdsLib: true,
    useLoadTopad: isSeOcelot,
    useRequestMultiVideoBids: isMultivideoSite,
    useNewAdUnitPath: isAllowedMotherhoodPage(),
  };
  if (dmScript) {
    amaModulesCache.prebidScript = dmScript;
  }
  if (adTags) {
    amaModulesCache.adTags = adTags;
  }
  return amaModulesCache;
}
